import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { REPORT } from "@/shared/resource/apis/endpoints";

export const useReportStore = defineStore("report", {
  state: () => ({
    reports:{
      list:[],
      totalCount:0,
      expenses:null
    }
  }),

  actions: {
    resetReportsData() {
      this.entities = [];
      this.totalEntities = 0;
    },

    async fetchReports(filters) {
      this.resetReportsData();
      const response = await api.get(REPORT.LIST, { params: {...filters}});

      const data = response?.data?.data?.trip_booking_details;
      const formattedEntities = data.slice().sort((a, b) => {
          return Number(a.trip_number) - Number(b.trip_number);
      }).map((report) => ({
        tripId: report.trip_id,
        tripNumber: report.trip_number,
        routeId: report.route_id,
        totalBookings: report.total_bookings,
        totalRevenue: report.total_revenue,
        tripStartTime: report.trip_start_time,
        tripType: report.trip_type,
        totalExpense: report.expenses || 0
      }));

      this.setReportsData(formattedEntities, response.data.total_entries || 0, response.data?.data?.expenses || []);
      return formattedEntities;
    },

    setReportsData(reports, totalCount, expenses) {
      this.reports.list = reports;
      this.reports.expenses = expenses;
      this.reports.totalCount = totalCount;
    },
  },

  getters: {
    getReports: (state) => state.reports,
  },
});
